import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { searchBox, hits, refinementList, stats, pagination, sortBy, currentRefinements, configure, menuSelect } from 'instantsearch.js/es/widgets';
import { connectPagination } from 'instantsearch.js/es/connectors';
import SearchCommon from '../search-common';

export default class ResourcesSearch {
    constructor(ResourcesElement) {
        this.resourcesElement = ResourcesElement;
        this.searchCommon = new SearchCommon(this.resourcesElement);
    }

    init() {
        const searchClient = algoliasearch(tsAlgoliaConfig.algoliaAppId, tsAlgoliaConfig.algoliaPublicReadApikey);

        const algoliaInstantSearch = instantsearch({
            indexName: tsAlgoliaConfig.algoliaResourcesIndexName + '_date_desc',
            searchClient,
            insights: false,
            routing: true
        });

        const customPagination = connectPagination(
            this.searchCommon.renderPagination
        );

        algoliaInstantSearch.addWidgets([
            searchBox({
                container: "#searchbox",
                placeholder: 'Search word',
                templates: {
                    reset({ cssClasses }, { html }) {
                        return html`
                          <svg class="ais-SearchBox-resetIcon" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-width="2" d="M1.293 17.293 17.556 1.029M1.707 1.293l16.264 16.263" />
                          </svg>
                        `
                    },
                    submit({ cssClasses }, { html }) {
                        return html`
                        <svg class="ais-SearchBox-submitIcon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8.66" cy="7" r="6" stroke-width="1.5" />
                          <path d="m1 15.004 3.66-3.66" stroke-width="1.5" />
                        </svg>
                        `
                    },
                }
            }),

            refinementList({
                container: '#contenttype-refinement',
                attribute: 'templateName',
                limit: 5,
                showMore: true,
                showMoreLimit: 100,
                templates: {
                    showMoreText(data, { html }) {
                        if (data.isShowingMore) {
                            return html`<span class="showless">Show Less</span>`;
                        } else {
                            return html`<span class="showmore">Show More</span>`;
                        }
                    }
                }
            }),

            refinementList({
                container: '#stage-refinement',
                attribute: 'relatedStages',
                limit: 5,
                showMore: true,
                showMoreLimit: 100,
                templates: {
                    showMoreText(data, { html }) {
                        if (data.isShowingMore) {
                            return html`<span class="showless">Show Less</span>`;
                        } else {
                            return html`<span class="showmore">Show More</span>`;
                        }
                    }
                }
            }),

            refinementList({
                container: '#topic-refinement',
                attribute: 'relatedTopics',
                limit: 5,
                showMore: true,
                showMoreLimit: 100,
                templates: {
                    showMoreText(data, { html }) {
                        if (data.isShowingMore) {
                            return html`<span class="showless">Show Less</span>`;
                        } else {
                            return html`<span class="showmore">Show More</span>`;
                        }
                    }
                }
            }),

            hits({
                container: '#hits',
                templates: {
                    item(hit, { html, components, sendEvent }) {
                        hit.eyebrowLinkText = hit.eyebrowLinkText.replace('&#38;', '&');
                        hit.primaryLinkText = hit.primaryLinkText.replace('&#38;', '&');
                        return html`
                  <li class="ais-Hits-item">
                  <div class="rounded h-full bg-white flex flex-col px-4 py-6 lg:p-8 justify-between">
                    <div class="flex flex-col gap-4 pb-5">
                      <a href="${hit.eyebrowLinkUrl}" class="type-zeta link underline underline-offset-4">${hit.eyebrowLinkText}</a>
                      <h3 class="line-clamp-5 lg:line-clamp-3">
                        <a href="${hit.primaryLinkUrl}" target="${hit.primaryLinkTarget}" class="type-delta text-light-purple link">${hit.primaryLinkText}</a>
                      </h3>
                    </div>
                    <div class="type-small-paragraph opacity-60">${hit.templateName}</div>
                  </div>
                </li>
                  `;
                    }
                }
            }),

            customPagination({
                container: document.querySelector('#pagination'),
            }),

            stats({
                container: '#stats',
                templates: {
                    text(data, { html }) {
                        let searchCommon = new SearchCommon();
                        return html`
                <span class="ais-Stats-text">${searchCommon.renderPageString(data.page, data.hitsPerPage, data.nbHits)}</span>
                `
                    },
                }
            }),

            stats({
                container: '#stats-mob',
                templates: {
                    text(data, { html }) {
                        let searchCommon = new SearchCommon();
                        return html`
                <span class="ais-Stats-text">${searchCommon.renderPageString(data.page, data.hitsPerPage, data.nbHits)}</span>
                `
                    },
                }
            }),


            sortBy({
                container: '#sortby',
                items: [
                    { label: 'Date (Newest)', value: tsAlgoliaConfig.algoliaResourcesIndexName+'_date_desc' },
                    { label: 'Date (Oldest)', value: tsAlgoliaConfig.algoliaResourcesIndexName+'_date_asc' },
                    { label: 'Title (Asc)', value: tsAlgoliaConfig.algoliaResourcesIndexName+'_title_asc' },
                    { label: 'Title (Desc)', value: tsAlgoliaConfig.algoliaResourcesIndexName+'_title_desc' },
                ],
            }),

            currentRefinements({
                container: '#currentrefinements',
                transformItems(items) {
                    items = items.map(item => {
                        if (item.attribute == 'templateName') {
                            item.label = 'Type';
                        } else if (item.attribute == 'relatedStages') {
                            item.label = 'Stage';
                        } else if (item.attribute == 'relatedTopics') {
                            item.label = 'Topic';
                        }
                        return item;
                    });
                    if (!resourcesSearchConfigurationParameters.contentTypesVisible) {
                        items = items.filter(item => item.attribute !== 'templateName');
                    }
                    if (!resourcesSearchConfigurationParameters.stagesVisible) {
                        items = items.filter(item => item.attribute !== 'relatedStages');
                    }
                    if (!resourcesSearchConfigurationParameters.topicsVisible) {
                        items = items.filter(item => item.attribute !== 'relatedTopics');
                    }
                    return items;
                },
            }),
        ]);

        if (resourcesSearchConfigurationParameters.preselectedContentTypes.length > 0) {
            algoliaInstantSearch.addWidget(
                configure({
                    disjunctiveFacetsRefinements: {
                        templateName: resourcesSearchConfigurationParameters.preselectedContentTypes,
                    },
                })
            );
        }

        if (resourcesSearchConfigurationParameters.preselectedStages.length > 0) {
            algoliaInstantSearch.addWidget(
                configure({
                    disjunctiveFacetsRefinements: {
                        relatedStages: resourcesSearchConfigurationParameters.preselectedStages,
                    },
                })
            );
        }

        if (resourcesSearchConfigurationParameters.preselectedTopics.length > 0) {
            algoliaInstantSearch.addWidget(
                configure({
                    disjunctiveFacetsRefinements: {
                        relatedTopics: resourcesSearchConfigurationParameters.preselectedTopics,
                    },
                })
            );
        }

        algoliaInstantSearch.start();
    }
}